<h3 mat-dialog-title>Grupo de acesso</h3>
<div mat-dialog-content style="width: 100%">
    <mat-form-field style="width: 100%">
        <input matInput placeholder="Nome" [formControl]="name" required maxlength="255">
        <mat-error *ngIf="name.invalid">{{getErrorNameMessage()}}</mat-error>
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button mat-button tabindex="2" (click)="onNoClick()">Cancelar</button>
    <button mat-button [disabled]="isInvalidForm()" (click)="salvar()" tabindex="-1">Salvar</button>
</div>